import { getDropDownProps } from "./dropDown/getDropDownProps";

export const getDefaultProps = ({ searchMode, searchParams }) => {
    const dropDown = getDropDownProps({ searchType: searchMode });

    const { isSearchPage, searchTerm } = searchParams;

    return {
        dropDown,
        inputValue: isSearchPage ? searchTerm : ""
    };
};
